import { render, staticRenderFns } from "./leftChart5.vue?vue&type=template&id=3cb872a6"
import script from "./leftChart5.vue?vue&type=script&lang=js"
export * from "./leftChart5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports